// © Copyright 2026 Emman Consulting SAS
import React from "react";
import { useDrag } from "@use-gesture/react";
import { FWC } from "../../data/albumData.js";

export default function FwcModal({ col, onTap, onReset, onDecrementDupe, onClose, lang }) {
  const oc = FWC.filter((s) => col[s.code]?.owned).length;

  const bind = useDrag(
    ({ down, movement: [, my], velocity: [, vy] }) => {
      const sh = document.querySelector(".msheet");
      if (!down) {
        if (my > 160 && vy > 0.3) { onClose(); }
        else if (sh) { sh.style.transform = ""; sh.style.opacity = ""; }
        return;
      }
      if (sh) {
        sh.style.transform = `translateY(${Math.max(0, my)}px)`;
        sh.style.opacity = 1 - (my / 300);
      }
    },
    { from: () => [0, 0], filterTaps: true, threshold: 20, pointer: { touch: true }, axis: "y" }
  );

  return (
    <div className="movl" onClick={onClose}>
      <div className="msheet" onClick={(e) => e.stopPropagation()}>
        <div className="mhandle" {...bind()} />
        <div className="mhdr">
          <i className="fi fi-sr-ball" style={{ fontSize: 28, lineHeight: 1, color: "#F5B800" }} />
          <div>
            <div className="mtname">Especiales FWC</div>
            <div className="mtcode">19 stickers especiales</div>
          </div>
          <div className="mprog">{oc}/19</div>
        </div>
        <div className="mbody">
          {FWC.map((s) => {
            const st = col[s.code] || { owned: false, quantity: 0 };
            const isDupe = st.owned && st.quantity > 0;
            return (
              <div key={s.code} className={"srow" + (isDupe ? " dupe" : st.owned ? " owned" : "")} onClick={() => onTap(s.code)}>
                <div className="srowl">
                  <div className="srowcode">{s.code}</div>
                  <div className="srown">
                    <span style={{ color: "#F5B800", marginRight: 4 }}>★</span>
                    Especial {s.code.split(" ")[1]}
                  </div>
                </div>
                <div className="srowr">
                  {isDupe && <span className="dbadge">×{st.quantity}</span>}
                  {st.owned && (
                    <button
                      className="rstbtn"
                      onClick={(e) => {
                        e.stopPropagation();
                        st.quantity > 0 ? onDecrementDupe(s.code) : onReset(s.code);
                      }}
                    >×</button>
                  )}
                  <div className="chkc">{st.owned ? "✓" : ""}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
